/* tslint:disable:indent */
/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import {Routes} from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {permissions} from '../../permissions';
import {AuthGuardService as AuthGuard} from '../../auth-guard.service';
import {TransactionDurationReportComponent} from './transaction-duration-report/transaction-duration-report.component';
import {AsnRunTimeListComponent} from './asn-run-time-list/asn-run-time-list.component';
import {OrderConfirmationRunTimeComponent} from './order-confirmation-run-time/order-confirmation-run-time.component';
import {ApisRunTimeComponent} from './apis-run-time/apis-run-time.component';
import {InvoiceRunTimeComponent} from './invoice-run-time/invoice-run-time.component';
import {TransactionDurationReportCapacityComponent} from './transaction-duration-report-capacity/transaction-duration-report-capacity.component';

export const routes: Routes = [{
  path: 'transaction-reports/order-run-time',
  component: TransactionDurationReportComponent,
  canActivate: [AuthGuard, NgxPermissionsGuard],
  data: {
    title: 'Order Run Time',
    permissions: {
      only: ['KPI_METRICS']
    }
  },
}, {
    path: 'transaction-reports/order-run-time-capacity',
    component: TransactionDurationReportCapacityComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Order Run Time & Capacity',
        permissions: {
            only: ['KPI_METRICS']
        }
    },
}, {
	path: 'transaction-reports/asn-run-time-list',
	component: AsnRunTimeListComponent,
	canActivate: [AuthGuard, NgxPermissionsGuard],
	data: {
			title: 'ASN Run Time List',
			permissions: {
			only: ['KPI_METRICS']
		}
	},
}, {
	path: 'transaction-reports/order-confirmation-run-time',
	component: OrderConfirmationRunTimeComponent,
	canActivate: [AuthGuard, NgxPermissionsGuard],
	data: {
		title: 'Order Conformation Run Time',
		permissions: {
			only: ['KPI_METRICS']
		}
	},
}, {
	path: 'transaction-reports/apis-run-time',
	component: ApisRunTimeComponent,
	canActivate: [AuthGuard, NgxPermissionsGuard],
	data: {
			title: 'APIs Run Time',
			permissions: {
				only: ['KPI_METRICS']
			}
		},
	}, {
		path: 'transaction-reports/invoice-run-time',
		component: InvoiceRunTimeComponent,
		canActivate: [AuthGuard, NgxPermissionsGuard],
		data: {
		title: 'Invoice Run Time',
		permissions: {
			only: ['KPI_METRICS']
		}
	}
}];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transaction-reports/transaction-reports.routing.ts